<template>
  <InspirationListPage
    :page-name="pageName"
    :profession-task-seo-name="$route.params.professionTaskSeoName"
  />
</template>

<router>
{
name: 'inspirationProfessionTaskPage'
}
</router>

<script>
import InspirationListPage from "~/components/_refactored/inspirationPage/InspirationListPage.vue";
import { EVENT_PAGE_NAMES } from "~/data/pageNames";

export default {
  name: "InspirationProfessionTaskPage",
  components: {
    InspirationListPage,
  },
  layout: "DefaultLayout",
  setup() {
    return {
      pageName: EVENT_PAGE_NAMES.INSPIRATION_PROFESSION_TASK_PAGE,
    };
  },
};
</script>
